'use client';
import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import AppLogo from '@/components/ui/AppLogo';
import { Building2, Home, TrendingUp, Shield } from 'lucide-react';

export default function AuthClient() {
  const [mode, setMode] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen flex" dir="rtl">
      {/* Brand Panel */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 via-primary-500 to-sky-400 flex-col justify-between p-10 relative overflow-hidden">
        {/* Background decoration */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-64 h-64 rounded-full bg-white" />
          <div className="absolute bottom-32 left-10 w-40 h-40 rounded-full bg-white" />
          <div className="absolute top-1/2 left-1/3 w-20 h-20 rounded-full bg-white" />
        </div>

        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <AppLogo size={44} />
            <span className="font-display text-2xl font-800 text-white">Directly</span>
          </div>
        </div>

        <div className="relative z-10">
          <h2 className="text-3xl font-800 text-white leading-tight mb-4">
            أدرج عقارك مجاناً<br />وتواصل مع الباحثين
          </h2>
          <p className="text-primary-100 text-base mb-8 leading-relaxed">
            منصة عقارية تجمع الملاك والباحثين في مكان واحد — بلا عمولات، بلا رسوم إدراج.
          </p>

          <div className="space-y-4">
            {[
              { icon: Building2, title: 'إدراج مجاني', desc: 'أضف عقارك للبيع أو الإيجار بدون أي رسوم' },
              { icon: Home, title: 'تصفح حر', desc: 'تصفح آلاف الإعلانات بدون قيود' },
              { icon: TrendingUp, title: 'وصول واسع', desc: 'إعلانك يصل لآلاف الباحثين يومياً' },
              { icon: Shield, title: 'دفع آمن', desc: 'رسوم رمزية لكشف بيانات التواصل بأمان' },
            ]?.map(item => (
              <div key={`feature-${item?.title}`} className="flex items-start gap-3">
                <div className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                  <item.icon size={18} className="text-white" />
                </div>
                <div>
                  <div className="text-sm font-700 text-white">{item?.title}</div>
                  <div className="text-xs text-primary-100">{item?.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative z-10 text-xs text-primary-200">
          © 2026 Directly — All Rights Reserved
        </div>
      </div>
      {/* Form Panel */}
      <div className="flex-1 flex flex-col justify-center items-center px-6 py-10 bg-gray-50">
        {/* Mobile Logo */}
        <div className="lg:hidden flex items-center gap-2 mb-8">
          <AppLogo size={36} />
          <span className="font-display text-xl font-700 text-gray-900">Directly</span>
        </div>

        <div className="w-full max-w-md">
          {/* Tab Toggle */}
          <div className="flex bg-white border border-gray-200 rounded-xl p-1 mb-6 shadow-sm">
            <button
              onClick={() => setMode('login')}
              className={`flex-1 py-2.5 text-sm font-600 rounded-lg transition-all duration-200 ${
                mode === 'login' ? 'bg-primary-500 text-white shadow-sm' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              تسجيل الدخول
            </button>
            <button
              onClick={() => setMode('signup')}
              className={`flex-1 py-2.5 text-sm font-600 rounded-lg transition-all duration-200 ${
                mode === 'signup' ? 'bg-primary-500 text-white shadow-sm' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              إنشاء حساب
            </button>
          </div>

          {mode === 'login' ? (
            <LoginForm onSwitchToSignup={() => setMode('signup')} />
          ) : (
            <SignupForm onSwitchToLogin={() => setMode('login')} />
          )}
        </div>
      </div>
    </div>
  );
}